import client from './client'

export default class SiteNwpService {
  radioFrequencyDetails (siteId) {
    return client.get('api/site/' + siteId + '/nwp/radio-frequency')
  }

  sectors (siteId) {
    return client.get('api/site/' + siteId + '/nwp/sectors')
  }

  sectorDetails (siteId, sectorId) {
    return client.get('api/site/' + siteId + '/nwp/sector/' + sectorId + '/details')
  }

  cells (siteId, sectorId, groupId) {
    if (groupId) {
      return client.get('api/site/' + siteId + '/nwp/sector/' + sectorId + '/cells/' + groupId)
    }
    return client.get('api/site/' + siteId + '/nwp/sector/' + sectorId + '/cells')
  }

  cellDetails (siteId, sectorId, cellName) {
    return client.get('api/site/' + siteId + '/nwp/sector/' + sectorId + '/cell/' + cellName + '/details')
  }

  update (siteId, data) {
    return client.post('api/site/' + siteId + '/nwp/update', data)
  }
}
